
    import Vue from "vue";
    // Models
    import UnitPlan from "../../../store/units/UnitPlan";
    import UnitPlanPreLearning from "../../../store/planner/purpose/UnitPlanPreLearning";
    import UnitPlanSkill from "../../../store/planner/purpose/UnitPlanSkill";
    import UnitPlanAttitude from "../../../store/planner/purpose/UnitPlanAttitude";
    // Components
    import RomaNotification from "../../commons/RomaNotification.vue";
    import RomaPurposeModalForm from "./RomaPurposeModalForm.vue";
    import RomaConfirmDialog from "../../commons/RomaConfirmDialog.vue";
    // Lodash
    import {orderBy} from 'lodash';
    import UnitPlanComments from '../../../store/units/UnitPlanComments';
    import {
        TrashIcon,
        EditIcon
    } from 'vue-feather-icons';

    export default Vue.extend({
        name: "RomaPurpose",
        created() {
            this.setLoadingTables(true);

            // Items Maestros
            const request = new URLSearchParams("idPlanUnidad=" + this.unit.id);

            // Cargamos del endpoint
            this.$store.dispatch("getUnitPlanPurpose", this.unit.id).then(response => {
                this.request.id = response.data.content.id;
                this.request.description = response.data.content.proposito
                    ? response.data.content.proposito
                    : "";
                this.request.preLearnings =
                    response.data.content.selectedIdConocimientosPrevios; // Conocimiento previo
                this.request.skills = response.data.content.selectedIdAprendizajeNiveles; // Habilidades
                this.request.attitudes = response.data.content.selectedIdActitudes; // Actitudes

                this.setLoadingTables(false);
            });
        },
        props: {
            unit: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                noDataNotification: {
                    type: 'NOINFOFOUND',
                    title: '',
                    messages: ['Sin datos agregados.'],
                    customPosition: true,
                    showXIcon: false
                },
                optionsToChange: '',
                options: {
                    preLearningsOptions: {},
                    skillsOptions: {},
                    attitudesOptions: {},
                },
                itemsPerPage: 5,
                showDialogDeleteItem: false,
                deleteItemText: '',
                deleteDescription: '',
                selectedListToDeleteFrom: [],
                selectedItemToDelete: { id: 0 },
                preLearningModal: {
                    tittle: "Agregar aprendizaje previo",
                    item: {
                        nombre: ""
                    },
                    show: false
                },
                colorToModal: "",
                currentList: [],
                addSkills: null,
                userId: this.$store.state.user.userId,
                userPrivileges: this.$store.state.user.privileges,
                isUTP: this.$store.state.user.isUTP,
                dialog: false,
                valid: false,
                loader: {
                    loadingPurpose: false,
                    loadingPreLearnings: null,
                    loadingSkills: null,
                    loadingAttitudes: null
                },
                purposeHeaders: [
                    { text: "Nombre", value: "nombre" },
                    {
                        text: "Acciones",
                        value: "action",
                        sortable: false,
                        align: "right"
                    }
                ],
                request: {
                    id: 0,
                    description: "",
                    preLearnings: [],
                    skills: [],
                    attitudes: []
                }
            };
        },
        methods: {
            newPreLearning() {
                this.preLearningModal.tittle = this.$vuetify.lang.t('$vuetify.component.romaPurpose.addPreLearningTitle');
                this.preLearningModal.show = true;
                this.preLearningModal.item = { nombre: '' };
            },
            editPreLearning(item: any) {
                this.preLearningModal.tittle = this.$vuetify.lang.t('$vuetify.component.romaPurpose.editPreLearningTitle');
                this.preLearningModal.show = true;
                this.preLearningModal.item = Object.assign({}, item);
            },
            closePreLearningModal() {
                this.preLearningModal.show = false;
                this.preLearningModal.item.nombre = "";
            },
            addPreLearning() {
                const indexOfEditedElement: number = this.request.preLearnings.findIndex(
                    (preLearning: any) => Number.isInteger(preLearning.id) && preLearning.id === this.preLearningModal.item.id
                );
                if (indexOfEditedElement >= 0)
                    this.request.preLearnings[
                        indexOfEditedElement
                        ].nombre = this.preLearningModal.item.nombre;
                else
                    this.request.preLearnings.push({
                        id: this.request.preLearnings.length === 0 ? -1 : (this.request.preLearnings.length + 1) * -1,
                        nombre: this.preLearningModal.item.nombre,
                        idPlanUnidad: this.unit.id,
                        tipoConocimiento: 1,
                        selected: true
                    });

                this.closePreLearningModal();
                this.savePurpose('!Aprendizaje previo guardado¡');
            },
            setLoadingTables(loading: boolean) {
                this.loader.loadingPurpose = loading;
                Object.keys(this.loader).forEach((loaderKey: string) => {
                    if (loading) {
                        switch (loaderKey) {
                            case "loadingPreLearnings":
                                this.loader[loaderKey] = "primary";
                                break;
                            case "loadingSkills":
                                this.loader[loaderKey] = "roma_rcolor";
                                break;
                            case "loadingAttitudes":
                                this.loader[loaderKey] = "roma_acolor";
                                break;
                            default:
                                break;
                        }
                    } else {
                        this.loader[loaderKey] = null;
                    }
                });
            },
            addingSkills(skills: any[]) {
                this.request.skills = orderBy(this.request.skills.concat(skills), ['codigo']);
                this.savePurpose('!Habilidad añadida¡');
            },
            addingAttitudes(attitudes: any[]) {
                this.request.attitudes = orderBy(this.request.attitudes.concat(attitudes), ['codigo']);
                this.savePurpose('!Actitud añadida¡');
            },
            addItemBySubjectAndLevel(addSkills: boolean) {
                this.colorToModal = addSkills ? "roma_rcolor" : "roma_acolor";
                this.addSkills = addSkills;
                this.currentList = addSkills
                    ? this.request.skills
                    : this.request.attitudes;
                this.dialog = true;
            },
            mapToIds(arr: any[]): number[] {
                return arr.map(o => {
                    if (Number.isInteger(o)) return o;
                    return o.id;
                });
            },
            goDeleteItem(item: any, arr: Array<any>, text: string, textDescription: string ,optionsToChange: string) {
                this.deleteItemText = text;
                this.deleteDescription = textDescription;
                this.selectedListToDeleteFrom = arr;
                this.selectedItemToDelete = item;
                this.showDialogDeleteItem = true;
                this.optionsToChange = optionsToChange;
            },
            removeItemSelected() {
                const index = this.selectedListToDeleteFrom.findIndex((element: any) => element.id === this.selectedItemToDelete.id);
                if (index >= 0) {
                    this.selectedListToDeleteFrom.splice(index, 1);
                    const page: number = Math.ceil(this.selectedListToDeleteFrom.length/this.options[this.optionsToChange].itemsPerPage);
                    if (this.options[this.optionsToChange].page > page)
                        this.options[this.optionsToChange].page = page;
                }
                this.deleteItemText = '';
                this.selectedListToDeleteFrom = [];
                this.selectedItemToDelete = null;
                this.showDialogDeleteItem = false;
                this.savePurpose('¡Elemento removido!');
            },
            async savePurpose(successMessage: string) {
                this.setLoadingTables(true);

                const msj = {
                    show: true,
                    text: successMessage,
                    color: "success"
                };

                // Descripción propósito
                this.unit.description = this.request.description;
                UnitPlan.update({ data: this.unit });
                let item = { unitplan_id: this.unit.id };
                // Aprendizaje previo
                if (this.request.preLearnings.length > 0) {
                    UnitPlanPreLearning.delete(i => i.unitplan_id === this.unit.id);
                    this.request.preLearnings.forEach(i => {
                        item.preLearning_id = i.id;
                        UnitPlanPreLearning.insert({ data: item });
                    });
                }
                // Habilidades
                if (this.request.skills.length > 0) {
                    UnitPlanSkill.delete(i => i.unitplan_id === this.unit.id);
                    this.request.skills.forEach(i => {
                        item.skill_id = i.id;
                        UnitPlanSkill.insert({ data: item });
                    });
                }
                // Actitudes
                if (this.request.attitudes.length > 0) {
                    UnitPlanAttitude.delete(i => i.unitplan_id === this.unit.id);
                    this.request.attitudes.forEach(i => {
                        item.attitude_id = i.id;
                        UnitPlanAttitude.insert({ data: item });
                    });
                }

                // endpoint
                const params = {
                    id: this.request.id,
                    proposito: this.request.description,
                    selectedIdConocimientosPrevios: this.request.preLearnings,
                    selectedIdActitudes:
                        this.request.attitudes.length > 0
                            ? this.mapToIds(this.request.attitudes)
                            : [],
                    selectedIdAprendizajeNiveles:
                        this.request.skills.length > 0
                            ? this.mapToIds(this.request.skills)
                            : []
                };
                await this.$store.dispatch("setUnitPlanPurpose", params)
                    .then(response => {
                        if (response.data && response.data.status.code === 1) {
                            this.unit.updateStatus(response.data.content.status);
                            UnitPlan.update({ data: this.unit });
                            if (response.data.content.comment) UnitPlanComments.insert({ data: response.data.content.comment });
                            this.request.preLearnings = orderBy(response.data.content.purpose.selectedIdConocimientosPrevios, ['codigo', 'nombre']);
                        } else {
                            msj.text = 'No se pudo guardar el propósito';
                            msj.color = 'red';
                        }
                    });

                this.$store.state.snackbar = msj;
                this.setLoadingTables(false);
            },
            savePurposeDescription() {
                this.savePurpose('!Descripción del propósito guardada¡');
            },
        },
        components: {
            RomaPurposeModalForm,
            RomaConfirmDialog,
            RomaNotification,
            TrashIcon,
            EditIcon
        }
    });
